import React from "react";
import { getTokenData } from "../../../../services/Auth__Service";
import ProfilRoot from "./ProfilRoot";
import ProfilUserAdmin from "./ProfilUserAdmin";

const Profil = () => {
  return getTokenData().login === "admin" ? (
    <ProfilRoot />
  ) : (
    <ProfilUserAdmin />
  );
};

export default Profil;
